import type { Address, Hex } from "viem";
import type { PrivateKeyAccount } from "viem/accounts";
import type { Receipt, SettingsRecord } from "@woodpecker/protocol";
import type { ServiceEntry } from "./chain";
import type { MemoryClient } from "./clients";
import { paidWrite } from "./paid-write";

export interface SettingsWriteResult {
  tx: Hex;
  settings: SettingsRecord;
  receipt: Receipt;
}

/**
 * A write of the settings record as D75 says: the record goes to the memory service pending, which answers with its
 * receipt (1 of its token per commit); the Console checks the receipt, signs one Intent with its own identity, and
 * the memory's submitter settles on contract A; only then is the write confirmed (`paidWrite`).
 */
export async function paidSettingsWrite(opts: {
  memory: MemoryClient;
  entry: ServiceEntry;
  wallet: Address;
  payer: PrivateKeyAccount;
  chainId: number;
  contractA: Address;
  body: Partial<SettingsRecord>;
  replace?: boolean;
}): Promise<SettingsWriteResult> {
  const { result, receipt } = await paidWrite({
    entry: opts.entry,
    wallet: opts.wallet,
    payer: opts.payer,
    chainId: opts.chainId,
    contractA: opts.contractA,
    pending: () => opts.memory.putSettingsPending(opts.body, { replace: opts.replace, payer: opts.payer.address }),
    settle: (calls, signed) => opts.memory.settleSettings(calls, signed),
  });
  return { tx: result.tx, settings: result.settings, receipt };
}
